import { MessageSquareQuote } from "lucide-react";
import { Reveal, SectionHeading } from "@/components/Reveal";
import { SITE } from "@/data/site";

// Le recensioni reali (es. da Google) potranno essere inserite qui in futuro.
// Formato previsto: { text: "...", name: "Nome del cliente", source: "Google" }
const reviews = [];

export default function Recensioni() {
  return (
    <section id="recensioni" className="py-24 md:py-32 lg:py-40">
      <div className="max-w-[1400px] mx-auto px-6 md:px-12">
        <SectionHeading
          overline="Recensioni"
          title={<>La vostra soddisfazione è il nostro <span className="italic text-terracotta">risultato più importante</span></>}
        />
        <Reveal delay={0.1}>
          <p className="mt-6 max-w-2xl text-charred/70 leading-relaxed">
            La fiducia dei clienti ci aiuta a crescere e a migliorare ogni giorno. Dopo aver provato i nostri piatti, raccontaci la tua esperienza.
          </p>
        </Reveal>

        {reviews.length > 0 ? (
          <div className="mt-14 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
            {reviews.map((r) => (
              <blockquote key={r.name} className="h-full bg-sand rounded-lg p-7 flex flex-col">
                <p className="font-serif italic text-xl leading-snug text-charred flex-1">"{r.text}"</p>
                <footer className="mt-5 text-xs uppercase tracking-[0.2em] text-charred/50">{r.name}{r.source ? ` · ${r.source}` : ""}</footer>
              </blockquote>
            ))}
          </div>
        ) : (
          <Reveal delay={0.15} className="mt-14">
            <div className="border border-dashed border-charred/25 rounded-lg p-10 md:p-16 text-center bg-sand/50" data-testid="reviews-placeholder">
              <div className="mx-auto w-14 h-14 rounded-full bg-terracotta/10 grid place-items-center text-terracotta">
                <MessageSquareQuote size={24} />
              </div>
              <p className="mt-6 font-serif text-2xl md:text-3xl text-charred">Raccontaci la tua esperienza</p>
              <p className="mt-3 max-w-xl mx-auto text-charred/70 text-sm md:text-base leading-relaxed">
                Hai già provato i nostri piatti? La tua opinione è importante: lascia una recensione su Google e aiutaci a far conoscere la nostra cucina. Le recensioni dei clienti saranno pubblicate in questa sezione.
              </p>
            </div>
          </Reveal>
        )}

        <Reveal className="mt-16 bg-charred text-cream rounded-lg p-8 md:p-12 flex flex-col md:flex-row items-start md:items-center gap-6 justify-between">
          <div>
            <h3 className="font-serif text-3xl md:text-4xl">Ti è piaciuto SAPORÉ?</h3>
            <p className="mt-2 text-cream/60 text-sm md:text-base">La tua opinione è importante. Lascia una recensione e aiutaci a far conoscere la nostra cucina.</p>
          </div>
          <a href={SITE.reviewsUrl} target="_blank" rel="noopener noreferrer" data-testid="review-leave-btn"
            className="shrink-0 rounded-full bg-terracotta text-cream px-7 py-3.5 text-sm font-semibold hover:bg-terracotta-dark hover:-translate-y-0.5 transition-all duration-300">
            Lascia la tua recensione
          </a>
        </Reveal>
      </div>
    </section>
  );
}
